import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.25rem;
  padding: 1.5rem;
  margin: 1rem auto;

  & > .hefesto-title {
    margin-bottom: 1.5rem;
  }
`;

export const SummaryContainer = styled.div`
  display: flex;

  & > div {
    padding-right: 4.5rem;
  }
`;
